import React from 'react';
import { useAuth } from 'react-oidc-context';

const Login: React.FC = () => {
    const auth = useAuth();

    const handleLogin = () => {
        auth.signinRedirect();
    };

    return (
        <div>
            <h1>Welcome</h1>
            <button type="button" onClick={handleLogin}>
                Sign In
            </button>
        </div>
    );
};

export default Login;
